import { useMemo, type MouseEventHandler, type Ref } from 'react'
import type { PressableProps } from 'react-native'

type TPressableProps = PressableProps & {
  dataSet: Record<string, string | boolean>
  onClick: MouseEventHandler
  ref?: Ref<HTMLDivElement>
}

export const Pressable = ({ ref, ...props }: TPressableProps) => {
  const { onClick, onHoverIn, onHoverOut, onPress, onPressIn, onPressOut, dataSet, testID, ...otherProps } = props

  const dataSetAttributes = useMemo(() => {
    const newDataSet: { [key: string]: string | boolean } = {}
    Object.entries(dataSet || {}).forEach(([key, value]) => {
      newDataSet[`data-${key}`] = value
    })

    return newDataSet
  }, [dataSet])

  // Filter out props that are not valid for a div element
  const attributesForDiv: Record<string, unknown> = {}
  const divElement = useMemo(() => document.createElement('div'), [])
  const otherPropsByKey: Record<string, unknown> = otherProps
  for (const prop in otherProps) {
    if (prop in divElement || prop.toLowerCase() in divElement) {
      attributesForDiv[prop] = otherPropsByKey[prop]
    }
  }

  return (
    <div
      data-test-id={testID}
      {...dataSetAttributes}
      ref={ref}
      role="button"
      tabIndex={0}
      onClick={onClick || onPress}
      // @ts-expect-error - hack cross platform
      onMouseDown={onPressIn}
      // @ts-expect-error - hack cross platform
      onMouseUp={onPressOut}
      // @ts-expect-error - hack cross platform
      onMouseEnter={onHoverIn}
      // @ts-expect-error - hack cross platform
      onMouseLeave={onHoverOut}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          // @ts-expect-error - event given to onPress is a web event not a native one
          onPress?.(e)
        }
      }}
      {...attributesForDiv}
    />
  )
}

Pressable.displayName = 'Pressable'
